import React, { useEffect, useState } from 'react';
import { alpha, Typography, InputBase, Box, styled } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import clsx from 'clsx';

const StyledInputBase = styled(InputBase)({
	padding: 0,
	width: '100%',
	'& input': {
		'-webkit-appearance': 'none',
		'-moz-appearance': 'none',
		appearance: 'none',
		padding: '12px 8px',
		borderRadius: 4,
		backgroundColor: '#fff',
		transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
		border: '1px solid #ced4da',
		fontSize: 15,
		'&:focus': {
			boxShadow: `${alpha('#999999', 0.25)} 0 0 0 0.2rem`,
			borderColor: '#90caf9'
		}
	}
});

const StyledPaper = styled(Box)({
	backgroundColor: '#fff',
	marginTop: 8,
	color: '#586069',
	fontSize: 15
});

const StyledOption = styled(Box)({
	minHeight: 'auto',
	alignItems: 'flex-start',
	padding: 8,
	'&[aria-selected="true"]': {
		backgroundColor: 'transparent'
	},
	'&[data-focus="true"]': {
		backgroundColor: 'rgba(0, 0, 0, 0.04)'
	}
});

const StyledPopper = styled(Box)({
	position: 'relative'
});

const StyledLabel = styled(Typography)({
	marginBottom: 0
});

const Autosuggest = ({
	className,
	value,
	options,
	label,
	name,
	placeholder = 'Select',
	multiselect = false,
	handleChange,
	handleInputChange,
	disabled = false,
	...props
}) => {
	const [selected, setSelected] = useState({
		label: '',
		value: null
	});

	const handleOnChange = (event, newValue) => {
		setSelected(newValue);
		handleChange({
			target: {
				name: name,
				value: newValue?.value
			}
		});
	};

	useEffect(() => {
		if (typeof value != 'object') {
			setSelected(options.find((o) => o.value == value));
		} else {
			setSelected(value);
		}
	}, [value, options]);

	return (
		<div className={clsx(className?.root)}>
			<StyledLabel
				variant="body2"
				color="textSecondary"
				className={clsx(className?.label)}
			>
				{label}
			</StyledLabel>
			<Autocomplete
				multiple={multiselect}
				disableCloseOnSelect={multiselect}
				disabled={disabled}
				componentsProps={{
					paper: { component: StyledPaper },
					option: { component: StyledOption }
				}}
				value={selected}
				defaultValue={selected}
				onChange={(event, newValue) => {
					handleOnChange(event, newValue);
				}}
				onInputChange={(event, newInputValue) => {
					handleInputChange && handleInputChange(newInputValue);
				}}
				noOptionsText="No options"
				clearOnBlur
				handleHomeEndKeys
				options={options}
				getOptionLabel={(option) => option?.label || ''}
				getOptionSelected={(option, value) => option?.label == value?.label}
				renderInput={(params) => (
					<StyledInputBase
						placeholder={placeholder}
						ref={params.InputProps.ref}
						inputProps={{
							...params.inputProps,
							autoComplete: 'none'
						}}
						className={clsx(className?.inputBase)}
					/>
				)}
			/>
		</div>
	);
};

export default Autosuggest;
